import appConfigs from '@/app/appConfigurations'
import {
  PublicClientApplication,
  type AccountInfo,
  type RedirectRequest
} from '@azure/msal-browser'
import { reactive } from 'vue'

export const msalConfig = {
  auth: {
    clientId: appConfigs.ad_client_id,
    authority: appConfigs.ad_authority,
    redirectUri: appConfigs.ad_redirect_url,
    postLogoutUri: appConfigs.ad_post_logout_url
  },
  // cache: {
  //   cacheLocation: 'localStorage', // This configures where your cache will be stored
  //   storeAuthStateInCookie: false
  // }
}
export const graphScopes: RedirectRequest = {
  scopes: ['api://' + appConfigs.ad_client_id + '/Employees.Read.All']
}
export const state = reactive({
  isAuthenticated: false,
  user: null as AccountInfo | null
})

export const msalInstance = new PublicClientApplication(msalConfig)
